import o from"react";import{Carousel as r}from"@netfront/ui-library";const t=t=>{const{onMoveEnd:e,onMoveStart:n,slider:i}=t;return o.createElement(r,{slider:i,onMoveEnd:e,onMoveStart:n})};export{t as SliderSnippet};
//# sourceMappingURL=SliderSnippet.js.map
